export const ItemTypes = {
  MENUITEM: "menuitem",
};
